module.exports = {"id":"233138","name":"Yu Kobayashi","rating":"76","photo":"./data/images/photos/0/233138.png","club":{"name":"Kawasaki Front.","logo":"./data/images/clubs/KawasakiFront..png"},"positions":["BU","MD","MG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YuKobayashi0.json
// module id = 4437
// module chunks = 0